import {Box, HStack, Text} from '@tempo/core';
import Thumbnail from '@components/Thumbnail';
import {ContentType} from '@deezer/next/services/types/contentType';
import HighlightedText from '@components/Navigation/SearchBar/HighlightedText';
import {NavLink} from '@tempo/nextjs';
import React from 'react';
import type {PlaylistSearchResult} from '@deezer/next/services/api/Starmania/requests/search/types';

type PlaylistSearchResultItemProps = {
	query: string;
	playlist: PlaylistSearchResult;
};

export const PlaylistSearchResultItem = ({
	query,
	playlist,
}: PlaylistSearchResultItemProps) => {
	return (
		<NavLink href={playlist.redirectUrl}>
			<HStack spacing={3}>
				<Thumbnail
					id={String(playlist.id)}
					picture={playlist.picture}
					type={ContentType.Playlist}
					width={'62px'}
					height={'62px'}
					coverLink={false}
				/>
				<Box>
					<Text
						as="h4"
						variant="body.default.regular"
						data-testid="search-item-title"
						noOfLines={1}
					>
						<HighlightedText query={query}>{playlist.title}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						noOfLines={1}
						color="text.neutral.secondary.default"
					>
						by{' '}
						<HighlightedText query={query}>{playlist.author}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						color="text.neutral.secondary.default"
					>
						Deezer ID:{' '}
						<HighlightedText query={query}>
							{String(playlist.id)}
						</HighlightedText>
					</Text>
				</Box>
			</HStack>
		</NavLink>
	);
};

export default PlaylistSearchResultItem;
